// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.optionSelect[data-v-8159a05a] {\n  border-color: var(--v-warning-base);\n  opacity: 1;\n}\n.optionFade[data-v-8159a05a] {\n  opacity: 0.7;\n}\n.optionFade[data-v-8159a05a]:hover {\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
